import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-config',
  templateUrl: './broadcastings-config.component.html',
  styleUrls: ['./broadcastings-config.component.scss']
})
export class BroadcastingsConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
